import React from 'react';
import './ActionButton.css';

interface ActionButtonProps {
  onClick: () => void;
  variant?: 'primary' | 'success' | 'secondary' | 'info' | 'danger';
  children: React.ReactNode;
  title?: string;
  disabled?: boolean;
}

/**
 * Standardized action button for tables
 * Ensures consistent sizing across orders, drafts, and other tables
 *
 * To change button size globally, edit ActionButton.css
 */
const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  variant = 'primary',
  children,
  title,
  disabled = false
}) => {
  return (
    <button
      className={`action-btn action-btn-${variant}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      {children}
    </button>
  );
};

export default ActionButton;
